<template>
  <div class="prize-card" :class="setLayoutColor">
    <div class="prize-card__title">
      {{ title }}
    </div>
    <div class="prize-card__image">
      <img :src="image" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PrizeCard",
  props: {
    title: {
      type: String,
    },
    image: {
      type: String,
    },
  },
  computed: {
    layoutColor() {
      return this.$store.getters.GET_LAYOUT_COLOR;
    },
    setLayoutColor() {
      return `prize-card_${this.layoutColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.prize-card {
  width: 284px;
  height: 284px;
  border-radius: 26px;
  padding: 20px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  &_purple {
    background-color: $color-purple-30;
  }

  &_red {
    background-color: $color-dark-yellow;
    color: $color-red-30;
  }

  &__title {
    @include font("CeraPro", 18px, 500);
    padding-bottom: 20px;
  }

  &__image {
    width: 298px;
    height: 298px;
    position: absolute;
    top: 26%;
    border-radius: 50%;
    overflow: hidden;
    background-color: $color-white;
    display: flex;
    justify-content: center;

    & img {
      width: 78%;
      height: 74%;
      object-fit: cover;
    }
  }
}
</style>
